import styled from '@emotion/styled';

const headerHeight = 60;
const paddingTop = 8;

const PageLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const PageWrapper = styled.div`
  padding-top: calc(${headerHeight}px + ${paddingTop}px);
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`;

const SearchBoxWrapper = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
`;

export default {
  PageWrapper,
  SearchBoxWrapper,
  PageLayout,
};
